import React, {Component} from 'react';
import NavList from '../widgets/NavList';
import NavListItem from '../widgets/NavListItem';
import {matchPath} from 'react-router';
import {connect} from 'react-redux';
import {actions} from './syllabus.state';
import handleError from '../handleError';
import jsonFetch from '../jsonFetch';
import debounce from '../debounce';
import {actions as dirtyActions} from '../dirty.state';
import {push} from 'react-router-redux';
import {getVersionsSorted, isRetrieving} from './version.selectors';
import {getSelectedSet, getSelectedSetID} from './set.selectors';

const isVersionSelected = location => {
	return matchPath(location.pathname, {
		path: '/set/:setID/version/:versionID',
		exact: false,
		strict: false
	});
};

export class VersionList extends Component {
	constructor(props) {
		super(props);
		
		if (!props.versions || !props.versions.items || !props.versions.items.length || !isVersionSelected(props.location)) {
			this.fetchVersionListData(props);
		}
		
		const doSearchAfterDelay = debounce(value => {
			props.versionListRetrieving([]);
			const {setID} = this.props;
			jsonFetch(`${process.env.REACT_APP_API}/set/${setID}/version${value ? '?query=' + encodeURIComponent(value) : ''}`)
				.then(json => this.props.setID === setID && props.versionListRetrieved(json))
				.catch(props.handleError)
		}, 500);
		this.doSearchAfterDelay = e => doSearchAfterDelay(e.target.value.trim());
	}
	
	fetchVersionListData = ({setID, versionListRetrieving, versionListRetrieved}) => {
		if (setID !== 'new') {
			versionListRetrieving([]);
			jsonFetch(`${process.env.REACT_APP_API}/set/${setID}/version`)
				.then(json => this.props.setID === setID && versionListRetrieved(json))
				.catch(e => {
					versionListRetrieved([]); // To prevent indefinite loading animation
					handleError(e);
				});
		} else {
			versionListRetrieved([]);
		}
	};
	
	componentWillReceiveProps(nextProps) {
		if (this.props.setID !== nextProps.setID || this.props.location.pathname.includes('version') && !nextProps.location.pathname.includes('version')) {
			this.fetchVersionListData(nextProps);
		}
	}
	
	newVersion = () => {
		this.props.newVersion(this.props.setID);
	};
	
	render() {
		const {
			isDirty,
			setID,
			items,
			retrieving,
			selectedSet
		} = this.props;
		
		return selectedSet ? (
			<NavList className="VersionList stacked" theme="yellow" loading={retrieving} disabled={isDirty} onSearchChange={this.doSearchAfterDelay} onAdd={this.newVersion}>
				{items && items.length ? items.map(version => (
					<NavListItem
						key={version.uuid}
						path={`/set/${setID}/version/${version.uuid}`}
						to={`/set/${setID}/version/${version.uuid}/details`}
						name={version.name}
						status={version.status}
						suffix={`v${version.number}`}
						theme="yellow"
						disabled={isDirty}
					/>
				)) : null}
			</NavList>
		) : null;
	}
}

const ConnectedVersionList = connect(
	(state, ownProps) => ({
		isDirty: !!(state.dirty && state.dirty.keys && Object.keys(state.dirty.keys).length),
		setID: getSelectedSetID(state, ownProps),
		selectedSet: getSelectedSet(state, ownProps),
		items: getVersionsSorted(state, ownProps),
		retrieving: isRetrieving(state, ownProps)
	}),
	dispatch => ({
		versionListRetrieving: () => dispatch(actions.versionListRetrieving()),
		versionListRetrieved: data => dispatch(actions.versionListRetrieved(data)),
		handleError: handleError(dispatch),
		newVersion: setID => {
			dispatch(actions.versionNew());
			dispatch(push(`/set/${setID}/version/new/details`));
			dispatch(dirtyActions.dirtySet('new'));
		}
	})
)(VersionList);


export default ConnectedVersionList;


// WEBPACK FOOTER //
// ./src/syllabus/VersionList.js